import React, { Component } from 'react';
import dayjs from 'dayjs';
import { DateRangeFilter } from '@C/Utils';

import services from '@C/Reports/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Opening cash balance',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.opening_balance)}</>;
    },
  },
  {
    name: 'Cash received from duties',
    key: 'cash_received_from_duties',
    formatter(props) {
      return (
        <>
          {props.map((item, i) => (
            <React.Fragment key={i}>
              {item.shift_name} - {formatCurrency(item.amount)}
              <hr />
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  {
    name: 'Office Income',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.all_incomes)}</>;
    },
  },
  {
    name: 'Office Expenses',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.all_expenses)}</>;
    },
  },
  {
    name: 'Total cash collected for the day',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.total_cash_received)}</>;
    },
  },
  {
    name: 'Bank deposit',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.cash_deposit)}</>;
    },
  },
  {
    name: 'Closing cash balance',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.closing_balance)}</>;
    },
  },
];

class CashBookShiftWiseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cashbookList: [],
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    //this.getCashbookShiftwiseReport();
  }

  getCashbookShiftwiseReport = () => {
    this.setState({ loading: true });
    services
      .getCashbookShiftwiseReport(this.state)
      .then((res) => {
        this.setState({
          cashbookList: res.data.data.results,
          count: res.data.data.count,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 6;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value }, () =>
          this.getCashbookShiftwiseReport(),
        );
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState(
          {
            end_date: value,
            start_date: minStartDate.format('YYYY-MM-DD'),
          },
          () => this.getCashbookShiftwiseReport(),
        );
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState({ limit: this.limitInput.current.value }, () => {
      this.getCashbookShiftwiseReport();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, () => {
      this.getCashbookShiftwiseReport();
    });
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 1,
      },
      () => {
        //this.getCashbookShiftwiseReport();
      },
    );
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true, offset: 1 }, function () {
      this.getCashbookShiftwiseReport();
    });
  };

  render() {
    const { cashbookList } = this.state;
    return (
      <section className="widget list-table full-width inverted">
        <header>
          <h3> Cashbook Shiftwise Report</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  ></button>
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Closing balance: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      cashbookList[0]?.closing_balance.toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={cashbookList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: ` Cash Book Shift Wise- ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Cash Book Shift Wise Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Closing balance -  ${
                        cashbookList[0]?.closing_balance.toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSales: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { CashBookShiftWiseReport };
